const OrderActionTypes = {
    FETCH_ORDER_START: "FETCH_ORDER_START",
    FETCH_ORDER_SUCCESS: "FETCH_ORDER_SUCCESS",
    FETCH_ORDER_FAILURE: "FETCH_ORDER_FAILURE",
    GET_ORDER_START: "GET_ORDER_START",
    GET_ORDER_SUCCESS: "GET_ORDER_SUCCESS",
    GET_ORDER_FAILURE: "GET_ORDER_FAILURE",
}

export default OrderActionTypes; 